import { useWindowWidth as windowWidth } from '@react-hook/window-size/throttled';

import {
  MOBILE_WIDTH,
  TABLET_PORTRAIT_WIDTH,
  TABLET_LANDSCAPE_WIDTH,
  DESKTOP_WIDTH,
} from '../helpers/constants/responsive-breakpoints';

const useWindowWidth = () => {
  const innerWidth = windowWidth({ initialWidth: 1200 });

  return {
    isMobile: innerWidth <= MOBILE_WIDTH,
    isTabletPortrait: innerWidth > MOBILE_WIDTH && innerWidth <= TABLET_PORTRAIT_WIDTH,
    isTabletLandscape: innerWidth > TABLET_PORTRAIT_WIDTH && innerWidth <= TABLET_LANDSCAPE_WIDTH,
    isDesktop: innerWidth > TABLET_LANDSCAPE_WIDTH && innerWidth <= DESKTOP_WIDTH,
    isDesktopLarge: innerWidth > DESKTOP_WIDTH,
  };
};

export default useWindowWidth;
